import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import VideoIcon from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import LockIcon from '@wix/da-ds/pkg/Icons/24x24/Lock';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import ConditionalWrapper from '@wix/da-ds/pkg/ConditionalWrapper';
import { useDeviationViewContext } from '../../../../Context';
import { DeviationTypes } from '../../../../types/deviation';
import { usePrimaryTier } from '../../../../Tier/PrimaryTierContext';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import SubscribeButton from '../../../../Button/SubscribeButton';
import { getDeviationType, scaleToSize } from '../../../_helpers';
import { formatPrice } from '../../../TierProductCardDumb/utils';
import { useFullview } from '../../hooks/useFullview';
import Image from '../../Image';
import s from './SubPaywall.scss';
const SubPaywall = ({ width, height, deviation, showImage = false, isStatusArtStage = false, className })=>{
    var _deviation_author, _tier_tier;
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { isFullscreen } = useDeviationViewContext();
    const tier = usePrimaryTier(deviation);
    const { isSubscribedButBlocked } = useSubscriptionTier(deviation);
    var _deviation_isPublished;
    const { previewFile } = useFullview({
        stageWidth: width !== null && width !== void 0 ? width : 0,
        stageHeight: height !== null && height !== void 0 ? height : 0,
        source: deviation,
        allowFullviewSrcsetForPngs: (_deviation_isPublished = deviation.isPublished) !== null && _deviation_isPublished !== void 0 ? _deviation_isPublished : false
    });
    if (!tier) {
        return null;
    }
    const size = scaleToSize(previewFile !== null && previewFile !== void 0 ? previewFile : {
        width,
        height
    }, {
        width,
        height
    });
    const isFilm = getDeviationType(deviation) === DeviationTypes.FILM;
    const bodylocaleKey = getBodyLocaleKey(isMobile, isSubscribedButBlocked);
    const bodyText = t(bodylocaleKey, {
        username: deviation === null || deviation === void 0 ? void 0 : (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.username,
        price: formatPrice((_tier_tier = tier.tier) === null || _tier_tier === void 0 ? void 0 : _tier_tier.dollarPrice)
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames(s['root'], !showImage && s['no-image'], isStatusArtStage && s['status'], isFullscreen && s['fullscreen'], className),
        style: {
            width,
            height
        }
    }, showImage && /*#__PURE__*/ React.createElement("div", {
        className: s['overlay']
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Image, {
        deviation: deviation,
        width: size === null || size === void 0 ? void 0 : size.width,
        height: size === null || size === void 0 ? void 0 : size.height,
        isZoomed: false
    })), isFilm && /*#__PURE__*/ React.createElement(VideoIcon, {
        className: s['video-icon']
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['centered'],
        style: size
    }, /*#__PURE__*/ React.createElement(ConditionalWrapper, {
        condition: showImage,
        wrap: (children)=>/*#__PURE__*/ React.createElement(ThemeOverride, {
                theme: ThemeOptions.DARK
            }, children)
    }, /*#__PURE__*/ React.createElement(LockIcon, null)), /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, t(isSubscribedButBlocked ? 'deviationview.subpaywall.title.subscribedButBlocked' : 'deviationview.subpaywall.title')), /*#__PURE__*/ React.createElement("div", {
        className: s['main']
    }, bodyText), !isSubscribedButBlocked && /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            referral_info: ReferralType.CONTENT_PAGE
        }
    }, /*#__PURE__*/ React.createElement(SubscribeButton, {
        tier: tier
    }))));
};
SubPaywall.displayName = 'SubPaywall';
export default SubPaywall;
function getBodyLocaleKey(isMobile = false, isSubscribedButBlocked = false) {
    let bodyTextlocaleKey = 'deviationview.subpaywall.body';
    if (isSubscribedButBlocked) {
        // deviationview.subpaywall.body.subscribedButBlocked
        bodyTextlocaleKey += '.subscribedButBlocked';
    }
    if (isMobile) {
        // deviationview.subpaywall.body.mobile
        // deviationview.subpaywall.body.subscribedButBlocked.mobile
        bodyTextlocaleKey += '.mobile';
    }
    return bodyTextlocaleKey;
}

//# sourceMappingURL=SubPaywall.js.map